import React, { useRef, useState, useEffect } from 'react';
import './MediaPage.css';
import FooterSection from './FooterSection';
import VideosSection from './VideosSection';
import LanternLabs1 from '../assets/LanternLabs1.png';
import LanternLabs2_1 from '../assets/LanternLabs2-1.png';
import LanternLabs2 from '../assets/LanternLabs2.png';
import LanternLabs3copy from '../assets/LanternLabs3copy.png';
import LanternLabs3_1 from '../assets/LanternLabs3-1.png';
import LanternLabs3 from '../assets/LanternLabs3.png';

const MediaPage = () => {
    const pressRef = useRef(null);
    const [pressReleases, setPressReleases] = useState([]);

    useEffect(() => {
        // Fetch CMS data directly from public folder
        const fetchPressReleases = async () => {
            try {
                const response = await fetch('/PressReleases_CMS.json');
                if (!response.ok) throw new Error('Failed to load JSON');
                const data = await response.json();
                setPressReleases(data);
            } catch (error) {
                console.error('Error loading press releases:', error);
            }
        };
        fetchPressReleases();
    }, []);

    return (
        <div className="media-page-container">
            <main className="media-main-content">
                {/* Media Hero */}
                <section className="media-hero">
                    <img src={LanternLabs1} alt="" className="hero-bg-decor hero-decor-1" />
                    <img src={LanternLabs2_1} alt="" className="hero-bg-decor hero-decor-2" />
                    <img src={LanternLabs2} alt="" className="hero-bg-decor hero-decor-3" />
                    <img src={LanternLabs3copy} alt="" className="hero-bg-decor hero-decor-4" />
                    <img src={LanternLabs3_1} alt="" className="hero-bg-decor hero-decor-5" />
                    <img src={LanternLabs3} alt="" className="hero-bg-decor hero-decor-6" />

                    <div className="media-title-container">
                        <h1 className="media-title">MEDIA</h1>
                    </div>
                    <div className="media-hero-line"></div>
                </section>

                {/* Videos Section */}
                <VideosSection />

                {/* Press Releases Section - Sticky Left, Scroll Right */}
                <section className="press-releases-container" id="press-releases">
                    <div className="press-sticky-side">
                        <h2 className="press-heading">Press Releases</h2>
                    </div>
                    <div className="press-scroll-content" ref={pressRef}>
                        {pressReleases.map((item) => (
                            <div className="press-item" key={item.id}>
                                <p className="press-date">{item.date}</p>
                                <h3 className="press-title">{item.title}</h3>
                                <p className="press-description">{item.description}</p>
                                <a href={item.link} className="press-link" target="_blank" rel="noopener noreferrer">Read more</a>
                            </div>
                        ))}
                    </div>
                </section>

                <FooterSection />
            </main>
        </div>
    );
};

export default MediaPage;
